//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GeneralTable from '@/components/GeneralTable';
import { log } from 'util';
import checkPermission from '@/utils/permission'; // 权限判断函数

export default {
  name: 'Index',
  components: {
    GeneralTable: GeneralTable
  },
  data: function data() {
    return {
      tableName: 't_user',
      moduleName: 'user_list_module',
      url: {
        getUrl: '/user',
        method: 'post',
        query: {}
      },
      canSearch: checkPermission('master.user.list'),
      //true,
      canAdd: checkPermission('master.user.add'),
      //true,
      canEdit: checkPermission('master.user.edit'),
      //true,
      canDelete: checkPermission('master.user.delete'),
      //true,
      canBatchEdit: checkPermission('master.user.batch'),
      //true,
      canDownload: checkPermission('master.user.download'),
      //true
      canImport: checkPermission('master.user.import_data')
    };
  },
  created: function created() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 保存离开本页面时的查询条件，当再次进入本页面时回显
    if (this.$refs.GeneralTable) {
      sessionStorage.setItem(window.location.href + '_LIST_QUERY', JSON.stringify(this.$refs.GeneralTable.getListQuery()));
    }
    next();
  },
  methods: {}
};